module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid mt-5"
  }, [_c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-lg-3 col-md-4 col-sm-6 col-xs-12"
  }, [_c('h1', [_vm._v("Inloggen")]), _vm._v(" "), _c('b-form', {
    staticClass: "mb-3",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submit($event)
      }
    }
  }, [_c('b-alert', {
    attrs: {
      "variant": "danger",
      "show": _vm.hasError
    }
  }, [_vm._v(_vm._s(_vm.lastError.message))]), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "label-for": "email"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "email",
      "type": "email",
      "required": "",
      "placeholder": "Email"
    },
    model: {
      value: (_vm.credentials.username),
      callback: function($$v) {
        _vm.$set(_vm.credentials, "username", $$v)
      },
      expression: "credentials.username"
    }
  })], 1), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "label-for": "password"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "password",
      "type": "password",
      "required": "",
      "placeholder": "Wachtwoord"
    },
    model: {
      value: (_vm.credentials.password),
      callback: function($$v) {
        _vm.$set(_vm.credentials, "password", $$v)
      },
      expression: "credentials.password"
    }
  })], 1), _vm._v(" "), _c('b-button', {
    staticClass: "mt-4",
    class: {
      disabled: _vm.loginPending
    },
    attrs: {
      "size": "lg",
      "block": "",
      "type": "submit",
      "variant": "primary"
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loginPending),
      expression: "loginPending"
    }]
  }, [_c('i', {
    staticClass: "fas fa-spinner fa-spin"
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loginPending == false),
      expression: "loginPending == false"
    }]
  }, [_vm._v("Inloggen")])])], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5264dc3a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Login.vue
// module id = 1310
// module chunks = 1